module.exports = __webpack_public_path__ + "img/symbol_9.cc224410.png";